export default function Configure($stateProvider) {
    $stateProvider.state('societes-fournisseur', {
        parent: 'common',
        url: '/societes-fournisseur',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes-fournisseur.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'gestion;performance;laboratoire' },
        params: {
            genre: '8'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_FOURNISSEUR_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_donnees',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_FOURNISSEUR_LIST',
            order: 36
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_FOURNISSEUR_LIST'
    });

    $stateProvider.state('societes-fournisseur.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '8'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-fournisseur.list({genre: "8"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-fournisseur.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '8'
        },
        ncyBreadcrumb: {
            parent: 'societes-fournisseur.list({genre: "8"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-fournisseur.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '8'
        },
        ncyBreadcrumb: {
            parent: 'societes-fournisseur.list({genre: "8"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_FOURNISSEUR_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_FOURNISSEUR_NEW'
    });

    $stateProvider.state('societes-fournisseur.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '8'
        },
        ncyBreadcrumb: {
            parent: 'societes-fournisseur.list({genre: "8"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_FOURNISSEUR_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-fournisseur.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-fournisseur.new',
            genre: '8'
        },
        ncyBreadcrumb: {
            parent: 'societes-fournisseur.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
